import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const servicesData = [
  {
    id: 1,
    title: "ServiceNow Consulting",
    desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
    link: "/servicenow-consulting",
    image: "/assets/services/img1.png",
  },
  {
    id: 2,
    title: "ServiceNow Implementation",
    desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
    link: "/servicenow-implementation",
    image: "/assets/services/img2.png",
  },
  {
    id: 3,
    title: "ServiceNow ITSM",
    desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
    link: "/servicenow-itsm",
    image: "/assets/services/img3.png",
  },
  {
    id: 4,
    title: "ServiceNow ITOM & CMDB",
    desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
    link: "/servicenow-itom-cmdb",
    image: "/assets/services/img4.png",
  },
  {
    id: 5,
    title: "ServiceNow CSM",
    desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
    link: "/servicenow-csm",
    image: "/assets/services/img5.png",
  },
  {
    id: 6,
    title: "ServiceNow HRSD",
    desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
    link: "/servicenow-hrsd",
    image: "/assets/services/img6.png",
  },
  {
    id: 7,
    title: "ServiceNow AI & Automation",
    desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
    link: "/servicenow-ai-automation",
    image: "/assets/services/img7.png",
  },
  {
    id: 8,
    title: "ServiceNow Integration",
    desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
    link: "/servicenow-integration",
    image: "/assets/services/img8.png",
  },
  {
    id: 9,
    title: "ServiceNow Custom Development",
    desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
    link: "/servicenow-custom-development",
    image: "/assets/services/img1.png",
  },
  {
    id: 10,
    title: "ServiceNow Managed Services",
    desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
    link: "/servicenow-managed-services",
    image: "/assets/services/img2.png",
  },
  {
    id: 11,
    title: "ServiceNow Resource Augmentation",
    desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
    link: "/servicenow-resource-augmentation",
    image: "/assets/services/img3.png",
  },
{
    id: 12,

    title: "ServiceNow Center of Excellence (COE)",

    desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",

    link: "/servicenow-coe",

    image: "/assets/services/img7.png",
},
];

function Services() {
  return (
    <div className="bg-[#FFFFFF]">
      <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
        <div className="absolute inset-0 z-0">
          <img
            src="/assets/hospital/bg1.png"
            alt="Abstract 3D Background"
            className="w-full h-full object-cover"
          />
          <div
            style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
            className="hidden md:block absolute inset-0"
          ></div>
          <div
            style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
            className="block md:hidden absolute inset-0"
          ></div>
        </div>
        <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
          <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
            <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
              ServiceNow Solutions
            </h1>
            <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
              Technology. Transformation. Trust.
            </p>
          </div>
        </div>
      </section>
      {/* <ServiceNowOverviewSection /> */}
      <section className="lg:py-[100px] py-[60px]">
        <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-[20px]">
            {servicesData.map((e) => (
              <div key={e.id}>
                <ServiceCard service={e} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;

const ServiceCard = ({ service }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      initial={{ y: 0 }}
      animate={{ y: isHovered ? -15 : 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <div>
        <Link
          to={`/service${service.link}`}
          className="group outline-none relative block w-full h-[290px] rounded-[0px] overflow-hidden bg-[#ebeff3] transition-colors duration-500 hover:bg-[#01386A] focus:bg-[#01386A] active:bg-[#01386A] cursor-pointer"
        >
          {/* Right Background Decorative Image */}
          <div className="absolute top-0 right-[-5%] sm:right-0 w-[45%] sm:w-[40%] h-full pointer-events-none overflow-hidden flex items-center justify-end">
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-full object-contain object-right opacity-90 group-hover:opacity-20 group-focus:opacity-20 group-active:opacity-20 transition-all duration-500 transform group-hover:scale-105"
            />
          </div>

          <div className="relative z-10 flex flex-col justify-between h-full w-[85%] sm:w-[75%] p-8 lg:p-8">
            <h3 className="text-[16px] lg:text-[20px] font-[600] font-sora text-[#01386A] leading-[1.2] transition-colors duration-500 group-hover:text-white group-focus:text-white group-active:text-white">
              {service.title}
            </h3>

            <p className="absolute top-[105px] sm:top-[115px] pr-5 text-[14px] lg:text-[16px] font-[500] leading-[1.6] font-graphik text-gray-200 opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 group-focus:opacity-100 group-focus:translate-y-0 group-active:opacity-100 group-active:translate-y-0">
              {service.desc}
            </p>

            <div className="mt-auto flex items-center gap-2 text-[15px] font-sora font-[600] text-[#01386A] transition-opacity duration-300 group-hover:opacity-0 group-focus:opacity-0 group-active:opacity-0">
              <span>Read More</span>
              <ArrowUpRight size={18} className="text-[#ED6800]" />
            </div>
          </div>
        </Link>
      </div>
    </motion.div>
  );
};